const adobeIdStep = {
  title: "Adobe ID verification",
  createIdLabel: "Create my Adobe ID",
  signInLabel: "Sign in",
} as const;

export type AdobeIdStepContent = typeof adobeIdStep;
export default adobeIdStep;
